import React, { useRef, useState } from "react";
import EmailEditor from "react-email-editor";
import { unlayerSampleJSON } from "../../unlayerSampleJSON";

const emailJSON = unlayerSampleJSON;

export default function Home() {
  const [show, setShow] = useState(false);

  const emailEditorRef = useRef({ editor: {} });

  const exportHtml = () => {
    emailEditorRef.current.editor.exportHtml((data) => {
      const { html } = data;

      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(html)
          .then(() => {
            setShow({ copySuccess: "Copied!" });
            setTimeout(() => {
              setShow({ copySuccess: "" });
            }, 3000);
          })
          .catch((error) => {
            console.error("Failed to copy text to clipboard:", error);
          });
      } else {
        // Fallback for browsers that don't support Clipboard API
        const textArea = document.createElement("textarea");
        textArea.value = html;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        document.body.removeChild(textArea);

        setShow({ copySuccess: "Copied!" });
        setTimeout(() => {
          setShow({ copySuccess: "" });
        }, 3000);
      }
    });
  };

  const onLoad = () => {
    emailEditorRef.current.editor.loadDesign(emailJSON);
  };

  const products = [
    {
      id: 1,
      image:
        "https://img.thriftbooks.com/api/images/i/m/B4380A756292C0D50D92213A920E5A9E6C1DD713.jpg",
      title: "The Great Believers",
      description:
        "A page turner... An absorbing and emotionally riveting story about what it's like to live during times of crisis. The New York Times Book Review A dazzling new novel of friendship and redemption in the face of tragedy and loss set in 1980s Chicago and contemporary Paris In 1985, Yale Tishman, the development director for an art gallery in Chicago, is about to pull off an amazing coup, bringing in an extraordinary collection of 1920s paintings as a gift to the gallery.",
    },
    {
      id: 2,
      image:
        "https://img.thriftbooks.com/api/images/i/m/F0836F0E91E904515A5A47078C555303CCC67351.jpg",
      title: "The Hundred-Year House",
      description:
        "From the acclaimed author of The Great Believers, an original, mordantly witty novel about the secrets of an old-money family and their turn-of-the-century estate, Laurelfield. Meet the Devohrs: Zee, a Marxist literary scholar who detests her parents' wealth but nevertheless finds herself living in their carriage house; Gracie, her mother, who claims she can tell your lot in life by looking at your teeth; and Bruce, her step-father, stockpiling supplies for the Y2K apocalypse and perpetually late for his tee time. ",
    },
  ];

  return (
    <div>
      <div className="text-center p-2 border bg-body-secondary">
        <button className="btn btn-secondary" onClick={exportHtml}>
          Copy HTML
          <i className="fa fa-clone ms-2" aria-hidden="true"></i>
        </button>
        <span className="ms-1 text-success">{show.copySuccess}</span>
      </div>
      <EmailEditor
        ref={emailEditorRef}
        onLoad={onLoad}
        projectId={144031}
        tools={{
          "custom#product_tool": {
            data: {
              products,
            },
            properties: {
              productLibrary: {
                editor: {
                  data: {
                    products,
                  },
                },
              },
            },
          },
        }}
        options={{
          designTags: {
            business_name: "Email Builder",
            current_user_name: "A",
          },
          // customCSS: [
          //   "https://examples.unlayer.com/examples/product-library-tool/productTool.css",
          // ],
          // customJS: [
          //   window.location.protocol +
          //     "//" +
          //     window.location.host +
          //     "/custom.js",
          // ],
        }}
        style={{
          height: "100vh",
        }}
      />
    </div>
  );
}
